import { render, staticRenderFns } from "./RatingWidget.vue?vue&type=template&id=0bd24b90&"
import script from "./RatingWidget.vue?vue&type=script&lang=js&"
export * from "./RatingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports